import { palette as e } from "@leafygreen-ui/palette";
var i,
    t = {
  Dark: "dark",
  Light: "light"
},
    a = {
  1: 4,
  2: 8,
  3: 16,
  4: 24,
  5: 32,
  6: 64,
  7: 88
},
    o = {
  default: "'Euclid Circular A', Akzidenz, 'Helvetica Neue', Helvetica, Arial, sans-serif",
  serif: "'MongoDB Value Serif', 'Times New Roman', serif",
  code: "'Source Code Pro', Menlo, monospace",
  legacy: "Akzidenz, 'Helvetica Neue', Helvetica, Arial, sans-serif"
},
    n = {
  Body1: 13,
  Body2: 16
},
    l = {
  body1: {
    fontSize: n.Body1,
    lineHeight: 20
  },
  body2: {
    fontSize: n.Body2,
    lineHeight: 28
  },
  code1: {
    fontSize: 13,
    lineHeight: 20
  },
  code2: {
    fontSize: 15,
    lineHeight: 24
  },
  disclaimer: {
    fontSize: 12,
    lineHeight: 20
  }
},
    r = {
  Mobile: 320,
  Tablet: 768,
  Desktop: 1024,
  XLDesktop: 1440
};

function c(e, i, t) {
  return i in e ? Object.defineProperty(e, i, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[i] = t, e;
}

var g,
    d = (c(i = {}, t.Light, {
  default: "0 0 0 2px ".concat(e.white, ", 0 0 0 4px ").concat(e.blue.light1),
  input: "0 0 0 3px ".concat(e.blue.light1)
}), c(i, t.Dark, {
  default: "0 0 0 2px ".concat(e.black, ", 0 0 0 4px ").concat(e.blue.light1),
  input: "0 0 0 3px ".concat(e.blue.light1)
}), i),
    p = (c(g = {}, t.Light, {
  gray: "0 0 0 3px ".concat(e.gray.light2),
  green: "0 0 0 3px ".concat(e.green.light2),
  red: "0 0 0 3px ".concat(e.red.light2)
}), c(g, t.Dark, {
  gray: "0 0 0 3px ".concat(e.gray.dark2),
  green: "0 0 0 3px ".concat(e.green.dark3),
  red: "0 0 0 3px ".concat(e.yellow.dark3)
}), g);
export { n as BaseFontSize, t as Mode, r as breakpoints, d as focusRing, o as fontFamilies, p as hoverRing, a as spacing, l as typeScales };